export default "//static.tradera.net/touchweb/static/output/images/google-play-badge-nl.ce61c040.svg";